import Vue from 'vue'
import to from 'await-to-js'
import store from '@/config/vuex'
import client from '@/api/client'
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import {
  GTM_LABELS,
} from '@/services/external-communication/gtm/gtm-data-layer'
import { EMAIL_SUBSCRIPTION_TYPES } from '@/stores/email-subscriptions'
import preFilledNewsletterCheckboxQuery from '@/api/gql/_shared/email-subscription/query/pre-filled-newsletter-checkbox.gql'
import updateNewsletterSubscriptionMutation from '@/api/gql/_shared/email-subscription/mutation/update-newsletter-subscription.gql'
import registerToMailingListMutation from '@/api/gql/_shared/email-subscription/mutation/register-to-mailing-list.gql'

const EmailSubscriptionService = {
  async fetchSubscriptions({ email, type }) {
    if (type === EMAIL_SUBSCRIPTION_TYPES.preFilledNewsletterCheckbox) {
      const [error, result] = await to(
        client.query({
          query: preFilledNewsletterCheckboxQuery,
          variables: { email },
          fetchPolicy: 'network-only',
        })
      )
      if (error) {
        Vue.rollbar.error('Fetching email subscription failed.', { email, type, error })
      } else {
        store.commit('emailSubscriptions/addEmailSubscriptions', result.data)
      }
    } else {
      Vue.rollbar.error(new TypeError('Unsupported parameter "type" in fetchSubscriptions.'))
    }
  },

  async updateSubscriptions({ email, type, isNewsletterSubscribed, action }) {
    if (type === EMAIL_SUBSCRIPTION_TYPES.preFilledNewsletterCheckbox) {
      const [error, result] = await to(
        client.mutate({
          mutation: updateNewsletterSubscriptionMutation,
          variables: { email, isNewsletterSubscribed },
        })
      )
      if (error) {
        Vue.rollbar.error('Updating email subscription failed.', { email, type, error })
      } else {
        const { preFilledNewsletterCheckbox } = result.data.updateNewsletterSubscription
        store.commit('emailSubscriptions/addEmailSubscriptions', { preFilledNewsletterCheckbox })
        this.trackSubscription({ email, type, action })
      }
    } else {
      Vue.rollbar.error(new TypeError('Unsupported parameter "type" in updateSubscriptions.'))
    }
  },

  async registerToMailingList(variables) {
    const [error, result] = await to(
      client.mutate({ mutation: registerToMailingListMutation, variables })
    )
    if (error) {
      Vue.rollbar.error(error)
      return false
    }
    return !!result?.data?.registerToMailingList?.success
  },

  trackSubscription({ email, type, action }) {
    if (!email || !type || !action) {
      Vue.rollbar.error(
        new TypeError('Parameters "email", "type" and "action" need to be defined in payload.')
      )
      return
    }
    const subscription = store.getters['emailSubscriptions/getEmailSubscriptionsByType'](
      email,
      type
    )
    if (subscription.isChecked) {
      notifyExternalServices({
        action: ACTIONS.subscriptions,
        details: {
          action,
          label: GTM_LABELS.subscribed,
        },
      })
    }
  },
}

export default EmailSubscriptionService
